import { useComputed, useValue } from '@tldraw/state-react'
import { areArraysShallowEqual } from '@tldraw/utils'
import { uniq } from '../utils/uniq'
import { useEditor } from './useEditor'

/**
 * Reactive list of peer user IDs for collaborators currently shown in the UI.
 * This list includes user ids who are not on the user's current page.
 * Mirrors {@link Editor.getVisibleCollaborators} — peers fade out as they
 * transition to idle/inactive, without requiring a manual re-render.
 *
 * @returns The list of peer UserIDs
 * @public
 */
export function usePeerIds() {
	const editor = useEditor()

	const $userIds = useComputed(
		'userIds',
		() => uniq(editor.getVisibleCollaborators().map((p) => p.userId)).sort(),
		{ isEqual: areArraysShallowEqual },
		[editor]
	)

	return useValue($userIds)
}
